import { Button } from "antd";
import { TRANSITION_ACTION } from "features/ConsultRequest/core/constants";

/** Một nút cho mỗi phần tử allowedTransitions; không đọc vai trò. Tách riêng để sau đổi sang dropdown (Q-D). */
export default function ActionButtons({ permissions, onSelect, onAssign, onReassign }) {
  const { canAssign, canReassign, allowedTransitions = [] } = permissions || {};
  return (
    <div style={{ display: "flex", gap: 8 }}>
      {canAssign && (
        <Button type="primary" onClick={onAssign}>
          Phân công
        </Button>
      )}
      {canReassign && <Button onClick={onReassign}>Thay đổi kỹ thuật viên</Button>}
      {allowedTransitions.map((status) => (
        <Button
          key={status}
          type={TRANSITION_ACTION[status]?.primary ? "primary" : "default"}
          onClick={() => onSelect?.(status)}
        >
          {TRANSITION_ACTION[status]?.label || status}
        </Button>
      ))}
    </div>
  );
}
